import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
export var StyledContentAfterContainer = styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin: 3px;\n    box-sizing: content-box;\n"])));
//# sourceMappingURL=StyledContentAfterContainer.js.map